<div style="width: 40%; float:left">
  @if (errorVisible) {
  <div class="dx-card">
    <div class="textarea-wrapper">
      <dx-text-area [(value)]="errorMessage"
                    [autoResizeEnabled]="true"
                    [inputAttr]="{ 'aria-label': 'Notes' }">
      </dx-text-area>
    </div>
  </div>
  }
  <div class="dx-card">
    <dx-data-grid [dataSource]="clocksDataSource"
                  [showBorders]="true"
                  [showColumnHeaders]="false"
                  [columnAutoWidth]="true">
      <dxo-group-panel [visible]="false"></dxo-group-panel>

      <dxi-column dataField="linkType"
                  [groupIndex]="0"
                  groupCellTemplate="groupCellTemplate">
        <dxo-lookup [dataSource]="lookupData"
                    valueExpr="id"
                    displayExpr="name">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="deviceDate" dataType="datetime" caption="Data"></dxi-column>
      <dxi-column dataField="direction" dataType="string"></dxi-column>
      <dxi-column dataField="distanzaCantiereInMetri" dataType="number">
        <dxo-format type="fixedPoint"
                    [precision]="0">
        </dxo-format>
      </dxi-column>
      <dxi-column type="buttons">
        <dxi-button text="Apri"
                    icon="globe"
                    hint="Apri su Google Maps"
                    [onClick]="apriMaps">
        </dxi-button>
      </dxi-column>
      <div *dxTemplate="let data of 'groupCellTemplate'">
        <div>{{data.displayValue}}</div>
      </div>

    </dx-data-grid>
  </div>

  <div class="dx-field">
    <div class="dx-field-label"></div>
    <div class="dx-field-value">
      <dx-radio-group [items]="priorities"
                      [value]="currentPriority"
                      (onValueChanged)="onPriorityChange($event)"
                      layout="horizontal">
      </dx-radio-group>
    </div>
  </div>
</div>


<div style="width: 60%; float:right">
  <!-- old map -->
  @if(satellitare) {

  @if (mapVisible){
  <div class="map-holder">
    <dx-map #map
            center="41.890262, 12.49175"
            [zoom]="18"
            [height]="300"
            [autoAdjust]="true"
            width="100%"
            provider="azure"
            [apiKey]="apiKey"
            [controls]="true"
            type="hybrid"
            [markers]="markers">
      <dxo-api-key>
        azure="MY_AZURE_MAPS_KEY"
      </dxo-api-key>
    </dx-map>
    <div class="overlay-button">
      <dx-button icon="search"
                 (onClick)="togglePopup()">
      </dx-button>
    </div>
  </div>
  }
  <dx-popup [(visible)]="isPopupVisible"
            [hideOnOutsideClick]="true"
            [resizeEnabled]="true"
            [fullScreen]="true"
            [showTitle]="false"
            contentTemplate="popup-content">
    <div *dxTemplate="let data of 'popup-content'">
      <dx-map id="mapPopup"
              center="40.7061, -73.9969"
              [zoom]="18"
              [autoAdjust]="true"
              height="100%"
              width="100%"
              provider="azure"
              [apiKey]="apiKey"
              [controls]="true"
              type="satellite"
              [markers]="markers">
      </dx-map>
      <div class="overlay-button">
        <dx-button icon="close"
                   (onClick)="togglePopup()">
        </dx-button>
      </div>
    </div>
  </dx-popup>
  }


  <!-- new map -->

  <div class="map-page-container" [hidden]="satellitare">
    <div id="ol-map-{{key}}" class="map"></div>

    <!-- Popup -->
    <div id="popup-{{key}}" class="ol-popup">
      <a href="#" id="popup-closer-{{key}}" class="ol-popup-closer">×</a>
      <div id="popup-content-{{key}}"></div>
    </div>
    <div class="overlay-button2">
      <dx-button icon="search"
                 (onClick)="togglePopup()">
      </dx-button>
    </div>


    <dx-popup [(visible)]="isPopupVisible"
              [hideOnOutsideClick]="true"
              [resizeEnabled]="true"
              [fullScreen]="true"
              [showTitle]="false"
              contentTemplate="popup-content">
      <div *dxTemplate="let data of 'popup-content'">
        <dx-map id="mapPopup"
                center="40.7061, -73.9969"
                [zoom]="18"
                [autoAdjust]="true"
                height="100%"
                width="100%"
                provider="azure"
                [apiKey]="apiKey"
                [controls]="true"
                type="satellite"
                [markers]="markers">
        </dx-map>
        <div class="overlay-button">
          <dx-button icon="close"
                     (onClick)="togglePopup()">
          </dx-button>
        </div>
      </div>
    </dx-popup>



  </div>
</div>


